import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

function Tickets() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/support/tickets"); setItems(data); };
  useEffect(() => { load(); }, []);
  const setStatus = async (t, status) => { try { await api.post(`/admin/support/tickets/${t.id}/status`, null, { params: { status } }); toast.success("Updated"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };
  return (
    <div className="surface-card p-4 overflow-x-auto">
      <Table>
        <TableHeader><TableRow><TableHead>Subject</TableHead><TableHead>From</TableHead><TableHead>Priority</TableHead><TableHead>Status</TableHead><TableHead>Created</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
        <TableBody>
          {items.map((t) => (
            <TableRow key={t.id} data-testid={`ticket-${t.id}`}>
              <TableCell className="font-semibold">{t.subject}</TableCell>
              <TableCell className="text-sm">{t.submitted_by}</TableCell>
              <TableCell><Badge variant="outline">{t.priority}</Badge></TableCell>
              <TableCell><Badge>{t.status}</Badge></TableCell>
              <TableCell className="font-mono text-xs">{new Date(t.created_at).toLocaleString()}</TableCell>
              <TableCell className="text-right space-x-1">
                {t.status === "OPEN" && <Button size="sm" onClick={() => setStatus(t, "IN_PROGRESS")}>Pick</Button>}
                {t.status === "IN_PROGRESS" && <Button size="sm" onClick={() => setStatus(t, "RESOLVED")}>Resolve</Button>}
                {t.status !== "CLOSED" && <Button size="sm" variant="outline" onClick={() => setStatus(t, "CLOSED")}>Close</Button>}
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-10">No support tickets yet.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
}

function Section({ title }) {
  return <Card><CardContent className="p-8 text-center" data-testid={`support-${title.toLowerCase()}`}><h3 className="font-display text-xl font-bold mb-2">{title}</h3><p className="text-muted-foreground text-sm">This view becomes live as soon as the corresponding channel is configured.</p></CardContent></Card>;
}

export default function Support() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-support">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Support center</h1>
        <p className="text-muted-foreground">Customer tickets, live chat, escalations, bug reports, feature requests and knowledge base.</p>
      </div>
      <Tabs defaultValue="tickets">
        <TabsList>
          <TabsTrigger value="tickets" data-testid="sup-tab-tickets">Tickets</TabsTrigger>
          <TabsTrigger value="chat" data-testid="sup-tab-chat">Live chat</TabsTrigger>
          <TabsTrigger value="escalations" data-testid="sup-tab-esc">Escalations</TabsTrigger>
          <TabsTrigger value="bugs" data-testid="sup-tab-bugs">Bug reports</TabsTrigger>
          <TabsTrigger value="features" data-testid="sup-tab-fr">Feature requests</TabsTrigger>
          <TabsTrigger value="kb" data-testid="sup-tab-kb">Knowledge base</TabsTrigger>
        </TabsList>
        <TabsContent value="tickets"><Tickets /></TabsContent>
        <TabsContent value="chat"><Section title="Live chat" /></TabsContent>
        <TabsContent value="escalations"><Section title="Escalations" /></TabsContent>
        <TabsContent value="bugs"><Section title="Bug reports" /></TabsContent>
        <TabsContent value="features"><Section title="Feature requests" /></TabsContent>
        <TabsContent value="kb"><Section title="Knowledge base" /></TabsContent>
      </Tabs>
    </div>
  );
}
